import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import MailchimpSubscribe from "react-mailchimp-subscribe";
import { MAILCHIMP_API } from "../../utility";
import SubscribeForm from "./SubscribeForm";

const Subscribe = () => {
  return (
    <>
      <MailchimpSubscribe
        url={MAILCHIMP_API}
        render={({ subscribe, status, message }) => (
          <SubscribeForm
            status={status}
            message={message}
            onValidated={(subScribe) => subscribe(subScribe)}
          />
        )}
      />
    </>
  );
};

export default Subscribe;
